import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Approves ("approve") or rejects ("reject") the fund allocation of a Profit
// Distribution. Approving posts the Cash payments.
export const decideFundAllocation = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/profit_distribution/decideFundAllocation`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
